// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Form, Button, Row, Col } from "react-bootstrap";
// import { collection, addDoc } from "firebase/firestore/lite";
// import { db } from "./fbaseconfig";
// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     subject: "",
//     message: "",
//     submitted: false,
//     errors: {
//       firstname: "",
//       lastname: "",
//       email: "",
//       subject: "",
//       message: "",
//     },
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (formIsValid()) {
//       try {
//         await addDoc(collection(db, "contactus"), formData);
//         clearForm();
//         setFormData((prevState) => ({
//           ...prevState,
//           submitted: true,
//         }));
//       } catch (error) {
//         console.error("Error submitting form:", error);
//       }
//     }
//   };

//   const clearForm = () => {
//     setFormData({
//       firstname: "",
//       lastname: "",
//       email: "",
//       subject: "",
//       message: "",
//       submitted: false,
//       errors: {
//         firstname: "",
//         lastname: "",
//         email: "",
//         subject: "",
//         message: "",
//       },
//     });
//   };

//   const formIsValid = () => {
//     const { firstname, lastname, email, subject, message } = formData;
//     const errors = {};

//     if (!firstname.trim()) {
//       errors.firstname = "First name is required";
//     }

//     if (!lastname.trim()) {
//       errors.lastname = "Last name is required";
//     }

//     if (!email.trim()) {
//       errors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(email)) {
//       errors.email = "Email is invalid";
//     }

//     if (!subject.trim()) {
//       errors.subject = "Subject is required";
//     }

//     if (!message.trim()) {
//       errors.message = "Message is required";
//     }

//     setFormData((prevState) => ({
//       ...prevState,
//       errors: errors,
//     }));

//     return Object.values(errors).every((error) => error === "");
//   };

//   return (
//     <>
//       <section className="page-banner-wrap bg-cover">
//         {/* <div className="banner-text">Contact us</div> */}
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-md-12 col-12">
//               <div className="page-heading text-white">
//                 <div className="page-title">
//                   <h1>Contact Us</h1>
//                 </div>
//               </div>

//               <nav aria-label="breadcrumb">
//                 <ol className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     {/* <a href="index.html">Home</a> */}
//                     <Link to="/">Home</Link>
//                   </li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Contact Us
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="contact-page-wrap section-padding">
//         <div className="container">
//           {/* <div className="row">
//             <div className="col-lg-4 col-md-6 col-12">
//               <div className="single-contact-card card1">
//                 <div className="top-part">
//                   <div className="icon">
//                     <i className="fal fa-envelope"></i>
//                   </div>
//                   <div className="title">
//                     <h4>Email Address</h4>
//                     <span>Sent mail asap anytime</span>
//                   </div>
//                 </div>
//                 <div className="bottom-part">
//                   <div className="info">
//                     <p>info@dnksoftware.com</p>
//                   </div>
//                   <div className="icon">
//                     <i className="fal fa-arrow-right"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-6 col-12">
//               <div className="single-contact-card card2">
//                 <div className="top-part">
//                   <div className="icon">
//                     <i className="fal fa-phone"></i>
//                   </div>
//                   <div className="title">
//                     <h4>Phone Number</h4>
//                     <span>call us asap anytime</span>
//                   </div>
//                 </div>
//                 <div className="bottom-part">
//                   <div className="info">
//                     <p>+918975159231</p>
//                     <p>+919637539285</p>
//                     <p>+919923895353</p>
//                   </div>
//                   <div className="icon">
//                     <i className="fal fa-arrow-right"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-6 col-12">
//               <div className="single-contact-card card3">
//                 <div className="top-part">
//                   <div className="icon">
//                     <i className="fal fa-map-marker-alt"></i>
//                   </div>
//                   <div className="title">
//                     <h4>Office Address</h4>
//                     <span>Sent mail asap anytime</span>
//                   </div>
//                 </div>
//                 <div className="bottom-part">
//                   <div className="info">
//                     <p>DNK Software</p>
//                     <p>Hinjawadi Road, Pune 45</p>
//                   </div>
//                   <div className="icon">
//                     <i className="fal fa-arrow-right"></i>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div> */}
//           <div className="flex justify-center items-center min-h-screen">
//             <div className="flex justify-center gap-6 flex-wrap">
//               {/* Email Address Card */}
//               <div className="single-contact-card w-80">
//                 <div className="top-part flex items-center">
//                   <div className="icon">
//                     <i className="fal fa-envelope"></i>
//                   </div>
//                   <div className="title">
//                     <h4>Email Address</h4>
//                     <span>Sent mail asap anytime</span>
//                   </div>
//                 </div>
//                 <div className="bottom-part flex justify-between items-center">
//                   <p>info@dnksoftware.com</p>
//                   {/*<div className="icon">
//                     <i className="fal fa-arrow-right"></i>
//                   </div>*/}
//                 </div>
//               </div>

//               {/* Office Address Card */}
//               <div className="single-contact-card w-80">
//                 <div className="top-part flex items-center">
//                   <div className="icon">
//                     <i className="fal fa-map-marker-alt"></i>
//                   </div>
//                   <div className="title">
//                     <h4>Office Address</h4>
//                   </div>
//                 </div>
//                 <div className="bottom-part flex justify-between items-center">
//                   <div className="info">
//                     <p>DNK Software</p>
//                     <p>Hinjawadi Road, Pune - 411 045</p>
//                   </div>
//                   {/*<div className="icon">
//                     <i className="fal fa-arrow-right"></i>
//                   </div>*/}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row section-padding pb-0">
//             <div className="col-12 text-center mb-20">
//               <div className="section-title">
//                 <p>send us message</p>
//                 <h2>Say Hello or Message</h2>
//               </div>
//             </div>

//             <div className="col-12 col-lg-12">
//               <div className="contact-form">
//                 {formData.submitted ? (
//                   <>
//                     {" "}
//                     <p>Thank you for your message!</p>
//                     <Button
//                       variant="primary"
//                       onClick={() =>
//                         setFormData((prevState) => ({
//                           ...prevState,
//                           submitted: false,
//                         }))
//                       }
//                     >
//                       Send another message
//                     </Button>
//                   </>
//                 ) : (
//                   <Form
//                     noValidate
//                     onSubmit={handleSubmit}
//                     className="contact-form"
//                   >
//                     <Row className="mb-3">
//                       <Col md="6" className="mb-3 mb-md-0">
//                         <Form.Group controlId="firstname">
//                           <Form.Control
//                             type="text"
//                             name="firstname"
//                             placeholder="First name"
//                             value={formData.firstname}
//                             onChange={handleChange}
//                             isInvalid={!!formData.errors.firstname}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {formData.errors.firstname}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md="6">
//                         <Form.Group controlId="lastname">
//                           <Form.Control
//                             type="text"
//                             name="lastname"
//                             placeholder="Last name"
//                             value={formData.lastname}
//                             onChange={handleChange}
//                             isInvalid={!!formData.errors.lastname}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {formData.errors.lastname}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row className="mb-3">
//                       <Col md="6" className="mb-3 mb-md-0">
//                         <Form.Group controlId="email">
//                           <Form.Control
//                             type="email"
//                             name="email"
//                             placeholder="Email"
//                             value={formData.email}
//                             onChange={handleChange}
//                             isInvalid={!!formData.errors.email}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {formData.errors.email}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md="6">
//                         <Form.Group controlId="subject">
//                           <Form.Control
//                             type="text"
//                             name="subject"
//                             placeholder="Subject"
//                             value={formData.subject}
//                             onChange={handleChange}
//                             isInvalid={!!formData.errors.subject}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {formData.errors.subject}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row className="mb-3">
//                       <Col md="12">
//                         <Form.Group controlId="message">
//                           <Form.Control
//                             as="textarea"
//                             name="message"
//                             placeholder="Message"
//                             value={formData.message}
//                             onChange={handleChange}
//                             isInvalid={!!formData.errors.message}
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {formData.errors.message}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Button type="submit" className="theme-btn">
//                       Send Message
//                     </Button>
//                   </Form>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="cta-banner">
//         <div className="container-fluid bg-cover section-bg">
//           <div className="cta-content">
//             <div className="row align-items-center">
//               <div className="col-xl-7 text-white col-12 text-center text-xl-left">
//                 <h1>
//                   Ready To Get Free Consulations For <br /> Any Kind Of It
//                   Solutions ?{" "}
//                 </h1>
//               </div>
//               <div className="col-xl-5 col-12 text-center text-xl-right">
//                 <Link to={"/contact"} className="theme-btn mt-4 mt-xl-0">
//                   Get a quote
//                   <i className="icon-arrow-right-1"></i>
//                 </Link>
//                 <Link
//                   to={"/services"}  
//                   className="ml-sm-3 mt-4 mt-xl-0 theme-btn minimal-btn"
//                 >
//                   read more <i className="icon-arrow-right-1"></i>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { collection, addDoc } from "firebase/firestore/lite";
import { db } from "./fbaseconfig";

const Contact = () => {
  // =========================================================
  // FORM STATE
  // =========================================================

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    fullname: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);


  // =========================================================
  // HANDLE INPUT CHANGE
  // =========================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear error when user starts correcting the field
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };


  // =========================================================
  // FORM VALIDATION
  // =========================================================

  const formIsValid = () => {
    const newErrors = {
      fullname: "",
      email: "",
      subject: "",
      message: "",
    };

    if (!formData.fullname.trim()) {
      newErrors.fullname = "Full name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Please select a project.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Please enter your message.";
    }

    setErrors(newErrors);

    return Object.values(newErrors).every(
      (error) => error === ""
    );
  };


  // =========================================================
  // SUBMIT FORM
  // =========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formIsValid()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Save only useful form data to Firebase
      await addDoc(collection(db, "contactus"), {
        fullname: formData.fullname.trim(),
        email: formData.email.trim(),
        subject: formData.subject,
        message: formData.message.trim(),
        createdAt: new Date().toISOString(),
      });

      setSubmitted(true);

      setFormData({
        fullname: "",
        email: "",
        subject: "",
        message: "",
      });

      setErrors({
        fullname: "",
        email: "",
        subject: "",
        message: "",
      });

    } catch (error) {
      console.error("Error submitting form:", error);

      alert(
        "Something went wrong while sending your message. Please try again."
      );

    } finally {
      setIsSubmitting(false);
    }
  };


  // =========================================================
  // SEND ANOTHER MESSAGE
  // =========================================================

  const sendAnotherMessage = () => {
    setSubmitted(false);

    setFormData({
      fullname: "",
      email: "",
      subject: "",
      message: "",
    });

    setErrors({
      fullname: "",
      email: "",
      subject: "",
      message: "",
    });
  };


  // =========================================================
  // PAGE
  // =========================================================

  return (
    <>
      {/* =====================================================
          PAGE BANNER
      ===================================================== */}

      {/* <section className="page-banner-wrap bg-cover">

        <div className="container">

          <div className="row align-items-center">

            <div className="col-md-12 col-12">

              <div className="page-heading text-white">

                <div className="page-title">
                  <h1>Contact Us</h1>
                </div>

              </div>

              <nav aria-label="breadcrumb">

                <ol className="breadcrumb">

                  <li className="breadcrumb-item">
                    <Link to="/">
                      Home
                    </Link>
                  </li>

                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                  >
                    Contact Us
                  </li>

                </ol>

              </nav>

            </div>

          </div>

        </div>

      </section> */}
<section className="page-banner-wrap bg-cover contact-page-banner">

  {/* Decorative Elements */}
  <span className="contact-banner-circle contact-banner-circle-one"></span>
  <span className="contact-banner-circle contact-banner-circle-two"></span>
  <span className="contact-banner-line"></span>

  <div className="container">

    <div className="row align-items-center">

      <div className="col-md-12 col-12">

        <div className="page-heading text-white">

          {/* Small Gold Label */}
          <div className="contact-banner-label">
            <span></span>
            LET'S CONNECT
            <span></span>
          </div>

          <div className="page-title">
            <h1>Contact Us</h1>
          </div>

          <p className="contact-banner-subtitle">
            Let's discuss your ideas, projects and technology needs.
          </p>

        </div>

        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">

          <ol className="breadcrumb">

            <li className="breadcrumb-item">
              <Link to="/">
                Home
              </Link>
            </li>

            <li
              className="breadcrumb-item active"
              aria-current="page"
            >
              Contact Us
            </li>

          </ol>

        </nav>

      </div>

    </div>

  </div>

</section>

      {/* =====================================================
          MAIN CONTACT SECTION
      ===================================================== */}

      <section className="dnk-contact-page">

        <div className="container">


          {/* =================================================
              INTRO
          ================================================= */}

          <div
            className="dnk-contact-intro"
            data-aos="fade-up"
          >

            <span className="dnk-contact-label">
              LET'S WORK TOGETHER
            </span>

            <h2>
              Tell Us About Your
              <br />
              <span>Project or Business Need.</span>
            </h2>

            <p>
              Have an idea, business challenge or technology
              requirement? Tell us what you are looking for and
              our team will help you find the right solution.
            </p>

          </div>


          {/* =================================================
              CONTACT FORM
          ================================================= */}

          <div className="row justify-content-center">

            <div
              className="col-xl-10 col-lg-11 col-12"
              data-aos="fade-up"
              data-aos-delay="100"
            >

              <div className="dnk-contact-form-wrapper">


                {/* FORM HEADER */}

                <div className="dnk-form-heading">

                  <div className="dnk-form-icon">
                    <i className="fal fa-paper-plane"></i>
                  </div>

                  <div>

                    <span>
                      START A CONVERSATION
                    </span>

                    <h3>
                      How Can We Help?
                    </h3>

                    <p>
                      Share your requirement and our team
                      will get in touch with you.
                    </p>

                  </div>

                </div>


                {/* =================================================
                    SUCCESS MESSAGE
                ================================================= */}

                {submitted ? (

                  <div className="dnk-form-success">

                    <div className="dnk-success-icon">
                      <i className="fas fa-check"></i>
                    </div>

                    <h3>
                      Message Sent Successfully!
                    </h3>

                    <p>
                      Thank you for reaching out to DNK Software.
                      We have received your requirement and our
                      team will get back to you soon.
                    </p>

                    <Button
                      type="button"
                      className="theme-btn"
                      onClick={sendAnotherMessage}
                    >
                      Send Another Message
                      <i className="icon-arrow-right-1"></i>
                    </Button>

                  </div>

                ) : (

                  <Form
                    noValidate
                    onSubmit={handleSubmit}
                    className="dnk-modern-contact-form"
                  >


                    {/* =================================================
                        FULL NAME + EMAIL
                    ================================================= */}

                    <Row>

                      {/* FULL NAME */}

                      <Col md={6} className="mb-4">

                        <Form.Group controlId="fullname">

                          <Form.Label>
                            Full Name
                            <span>*</span>
                          </Form.Label>

                          <div className="dnk-input-wrapper">

                            <i className="fal fa-user"></i>

                            <Form.Control
                              type="text"
                              name="fullname"
                              placeholder="Enter your full name"
                              value={formData.fullname}
                              onChange={handleChange}
                              isInvalid={!!errors.fullname}
                            />

                          </div>

                          <Form.Control.Feedback type="invalid">
                            {errors.fullname}
                          </Form.Control.Feedback>

                        </Form.Group>

                      </Col>


                      {/* EMAIL */}

                      <Col md={6} className="mb-4">

                        <Form.Group controlId="email">

                          <Form.Label>
                            Email Address
                            <span>*</span>
                          </Form.Label>

                          <div className="dnk-input-wrapper">

                            <i className="fal fa-envelope"></i>

                            <Form.Control
                              type="email"
                              name="email"
                              placeholder="you@company.com"
                              value={formData.email}
                              onChange={handleChange}
                              isInvalid={!!errors.email}
                            />

                          </div>

                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>

                        </Form.Group>

                      </Col>

                    </Row>


                    {/* =================================================
                        PROJECT DROPDOWN
                    ================================================= */}

                    <Row>

                      <Col md={12} className="mb-4">

                        <Form.Group controlId="subject">

                          <Form.Label>
                            Interested In
                            <span>*</span>
                          </Form.Label>

                          <div className="dnk-input-wrapper dnk-select-wrapper">

                            <i className="fal fa-layer-group"></i>

                            <Form.Select
                              name="subject"
                              value={formData.subject}
                              onChange={handleChange}
                              isInvalid={!!errors.subject}
                            >

                              <option value="" selected>
                                Select the product you are interested in
                              </option>
                              
                              <option value="Offshore Partnership">
                                Offshore Partnership
                              </option>

                              <option value="IndusFlow">
                                IndusFlow
                              </option>

                              <option value="Docparser">
                                Docparser
                              </option>

                              <option value="CreditFlow">
                                CreditFlow
                              </option>

                              <option value="EasyFlow">
                                EasyFlow
                              </option>

                            </Form.Select>

                          </div>

                          <Form.Control.Feedback type="invalid">
                            {errors.subject}
                          </Form.Control.Feedback>

                        </Form.Group>

                      </Col>

                    </Row>


                    {/* =================================================
                        MESSAGE
                    ================================================= */}

                    <Row>

                      <Col md={12} className="mb-4">

                        <Form.Group controlId="message">

                          <Form.Label>
                            Tell Us About Your Requirement
                            <span>*</span>
                          </Form.Label>

                          <div className="dnk-input-wrapper dnk-textarea-wrapper">

                            <i className="fal fa-comment-alt"></i>

                            <Form.Control
                              as="textarea"
                              name="message"
                              rows={6}
                              placeholder="Tell us about your project, requirements, business challenge, timeline or anything else we should know..."
                              value={formData.message}
                              onChange={handleChange}
                              isInvalid={!!errors.message}
                            />

                          </div>

                          <Form.Control.Feedback type="invalid">
                            {errors.message}
                          </Form.Control.Feedback>

                        </Form.Group>

                      </Col>

                    </Row>


                    {/* =================================================
                        SUBMIT AREA
                    ================================================= */}

                    <div className="dnk-form-submit">

                      <div className="dnk-form-note">

                        <i className="fas fa-lock"></i>

                        <span>
                          Your information is kept confidential.
                        </span>

                      </div>


                      <Button
                        type="submit"
                        className="theme-btn dnk-submit-btn"
                        disabled={isSubmitting}
                      >

                        {isSubmitting
                          ? "Sending..."
                          : "Send Message"
                        }

                        {!isSubmitting && (
                          <i className="icon-arrow-right-1"></i>
                        )}

                      </Button>

                    </div>

                  </Form>

                )}

              </div>

            </div>

          </div>


          {/* =================================================
              CONTACT INFORMATION CARDS
          ================================================= */}

          <div
            className="dnk-contact-info-section"
            data-aos="fade-up"
          >

            <div className="row">


              {/* =================================================
                  EMAIL CARD
              ================================================= */}

              <div className="col-lg-6 col-md-6 col-12 mb-4">

                <div className="dnk-contact-info-card">

                  <div className="dnk-info-icon">
                    <i className="fal fa-map-marker-alt"></i>
                  </div>

                  <div className="dnk-info-content">
                  <span>
                      VISIT OUR OFFICE
                    </span>

                    <h4>
                      PUNE, INDIA
                    </h4>

                    <p className="dnk-address">

                      Ganesh Krupa Society
                      <br />

                      Lane No 12, Paud Rd
                      <br />

                      Paramahansa Nagar, Kothrud
                      <br />

                      Pune, Maharashtra 411038
                      <br/>
                       <i className="fal fa-envelope"></i>&nbsp;&nbsp;
                       <a href="mailto:hr@dnksoftware.com">
                      hr@dnksoftware.com
                      </a>
                      <br/>
                       <i className="fal fa-mobile"></i>&nbsp;&nbsp;
                       <a href="tel:+918975159231">
                          +91 8975159231
                      </a>
                    </p>


                  </div>

                  <div className="dnk-info-arrow">
                    <i className="fal fa-arrow-right"></i>
                  </div>

                </div>

              </div>


              {/* =================================================
                  OFFICE CARD
              ================================================= */}

              <div className="col-lg-6 col-md-6 col-12 mb-4">

                <div className="dnk-contact-info-card">

                  <div className="dnk-info-icon">
                    <i className="fal fa-map-marker-alt"></i>
                  </div>

                  <div className="dnk-info-content">

                    <span>
                      VISIT OUR OFFICE
                    </span>

                    <h4>
                      JOHANNESBURG, SOUTH AFRICA
                    </h4>

                    <p className="dnk-address">

                      5th Avenue
                      <br />

                      Edenburg
                      <br />

                      Sandton
                      <br />

                      Johannesburg, Gauteng 2128
<br/>
                       <i className="fal fa-envelope"></i>&nbsp;&nbsp;
                       <a href="mailto:enquiry@dnksoftware.co.za">
                      enquiry@dnksoftware.co.za
                      </a>
                      <br/>
                       <i className="fal fa-mobile"></i>&nbsp;&nbsp;
                       <a href="tel:+27603158719">
                          +27 603158719
                      </a>
                    </p>

                  </div>

                  <div className="dnk-info-arrow">
                    <i className="fal fa-arrow-right"></i>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section className="cta-banner">

        <div className="container-fluid bg-cover section-bg">

          <div className="cta-content">

            <div className="row align-items-center">

              <div className="col-xl-7 text-white col-12 text-center text-xl-left">

                <span className="dnk-cta-label">
                  LET'S BUILD SOMETHING USEFUL
                </span>

                <h1>
                  Have A Business Challenge?
                  <br />
                  Let's Build The Right Solution.
                </h1>

              </div>


              <div className="col-xl-5 col-12 text-center text-xl-right">

                <Link
                  to="/products"
                  className="theme-btn mt-4 mt-xl-0"
                >
                  Explore Products
                  <i className="icon-arrow-right-1"></i>
                </Link>

                {/* <Link
                  to="/services"
                  className="ml-sm-3 mt-4 mt-xl-0 theme-btn minimal-btn"
                >
                  View Services
                  <i className="icon-arrow-right-1"></i>
                </Link> */}

              </div>

            </div>

          </div>

        </div>

      </section>

    </>
  );
};

export default Contact;